/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LocalisationService } from '../../../core/services/localisation/zuper.localisation.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { assignedEmployee } from './assign-tooltip.component.interface';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-assign-tooltip',
  templateUrl: './assign-tooltip.component.html',
  styleUrls: ['./assign-tooltip.component.scss']
})
export class AssignEmployeeTooltipComponent implements OnInit, OnDestroy {

  @Input() assignListData: any;
  @Input() assignedEmployee: assignedEmployee;
  @Input() showNotifyEmployee: boolean = true;
  @Input() isMultiSelect: boolean = false;
  @Output() assignedEmployeeEmitter: EventEmitter<any> = new EventEmitter<any>();
  searchText: string = '';
  addNew: boolean = false;
  searchData: any = [];
  assignEmployeeForm: UntypedFormGroup = new UntypedFormGroup({
    assign: new UntypedFormControl(''),
    notify_users: new UntypedFormControl(true)
  });
  taskAssignmentSubscription: Subscription;
  taskAssignEmployeeSubscription: Subscription;
  constructor(private _localisationService: LocalisationService,
    private dataCollectorService: DataCollectorService,
    private jobService: JobsService,
    private changeDetectorRef: ChangeDetectorRef,
    public utilityService: UtilityService,
    public tippyService: NgxTippyService,
    private toast: HotToastService
  ) { }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    if (!this.isMultiSelect) {
      if (this.utilityService.isEmptyOrUndefined(this.assignListData)) {
        this.assignListData = [{ value: 'unassign' }];
      } else {
        this.assignListData = [{ value: 'unassign' }, ...this.assignListData];
      }
    } else {
      const selectedEmployees: string[] = [];
      this.assignListData.forEach((data: any) => {
        selectedEmployees.push(data.user.user_uid + '_' + (data?.team?.team_uid || ''));
      });
      this.assignEmployeeForm?.controls?.assign?.setValue(selectedEmployees);

    }

    this.getAssignedLists();
  }

  ngOnDestroy(): void {
    if (this.taskAssignmentSubscription?.unsubscribe) {
      this.taskAssignmentSubscription?.unsubscribe();
    }

    if (this.taskAssignEmployeeSubscription) {
      this.taskAssignEmployeeSubscription?.unsubscribe();
    }
  }

  getAssignedLists(): void {
    this.taskAssignmentSubscription = this.jobService.taskAssignment.subscribe(
      (res: any) => {
        this.assignListData = [{ value: 'unassign' }, ...res];
      }
    );

    this.taskAssignEmployeeSubscription = this.jobService.taskAssignedEmployee.subscribe((res: any) => {
      if (this.isMultiSelect) {
        const selectedEmployees: string[] = [];
        res?.forEach((data: any) => {
          selectedEmployees.push(data.user.user_uid + '_' + (data?.team?.team_uid || ''));
        });
        this.assignEmployeeForm?.controls?.assign?.setValue(selectedEmployees);
      } else {
        if (res?.user?.user_uid && res?.team?.team_uid) {
          this.assignEmployeeForm?.controls?.assign?.setValue(res.user.user_uid + '_' + res?.team?.team_uid);
        } else if (res?.user?.user_uid) {
          this.assignEmployeeForm?.controls?.assign?.setValue(res.user.user_uid + '_');
        } else {
          this.assignEmployeeForm?.controls?.assign?.setValue('unassign');
        }
      }
    });
  }

  getUsers(searchText: string): void {
    const params = {
      'filter.keyword': searchText,
      'is_assigned_to_team': true,
      'limit': 10,
      'page': 1,
      'populate_teams': true
    };
    this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.allUsersUrl, params).subscribe((response: any) => {
      let userData = [];
      for (const element of response?.data) {
        const users = element?.teams.map((data: any) => ({ user: element, team: data }));
        userData = [...userData, ...users];
      }
      this.searchData = userData;
    }, (error: any) => {
      
    });
  }

  selectUser(user): void {
    this.assignListData = this.assignListData.filter((data: any) => !((data?.user?.user_uid === user?.user?.user_uid) && (data?.team?.team_uid === user?.team?.team_uid)));
    this.assignListData = [...this.assignListData, user];
    if (this.isMultiSelect) {
      const selectedUsers: any[] = this.assignEmployeeForm.value.assign || [];
      selectedUsers.push(user?.user?.user_uid + '_' + (user?.team?.team_uid || ''));
      this.assignEmployeeForm.controls.assign.setValue(selectedUsers);
    } else {
      this.assignEmployeeForm.controls.assign.setValue(null);
      this.assignEmployeeForm.controls.assign.setValue(user?.user?.user_uid + '_' + user?.team?.team_uid);
    }
    this.addNew = false;
    delete user?.user?.teams;
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
    }, 500);
  }

  emitAssignedEmployee(): void {
    if (this.assignEmployeeForm.value.assign) {
      if (!this.isMultiSelect) {
        const emitData = {
          'type': this.assignEmployeeForm.value.assign === 'unassign' ? 'UNASSIGN' : 'ASSIGN',
          'assigned':
          {
            team: this.assignEmployeeForm.value.assign === 'unassign' ?
              this.assignedEmployee?.team :
              this.assignListData?.find((element: any) => element?.user?.user_uid === this.assignEmployeeForm.value.assign?.split('_')[0] && element?.team?.team_uid === this.assignEmployeeForm.value.assign?.split('_')[1])?.team,
            user: this.assignEmployeeForm.value.assign === 'unassign' ?
              this.assignedEmployee?.user :
              this.assignListData?.find((element: any) => element?.user?.user_uid === this.assignEmployeeForm.value.assign?.split('_')[0])?.user
          },
          'notify_users': this.assignEmployeeForm.value.notify_users
        };
        this.assignedEmployeeEmitter.emit(emitData);
      } else {
        const emitData: any[] = [];
        const selectedEmployees: string[] = this.assignEmployeeForm.value.assign;
        selectedEmployees.forEach((selectedUserId: string) => {
          emitData.push({
            team: this.assignListData?.find((element: any) => element?.user?.user_uid === selectedUserId?.split('_')[0] && element?.team?.team_uid === selectedUserId?.split('_')[1])?.team,
            user: this.assignListData?.find((element: any) => element?.user?.user_uid === selectedUserId?.split('_')[0])?.user
          });
        });
        this.assignedEmployeeEmitter.emit(emitData);
      }
    }
  }

  //#region Multi Select Employee
  isSelectedEmployee(employeeInfo: any): boolean {
    const assignedEmployees: any[] = this.assignEmployeeForm.value.assign;
    const employeeId: string = employeeInfo?.user?.user_uid + '_' + (employeeInfo?.team?.team_uid || '');
    if (employeeId) {
      return assignedEmployees.find(user => user === employeeId) ? true : false;
    }
    return false;
  }

  updateEmployeeAssign(event: any, employeeInfo: any): void {
    const assignedEmployees: any[] = this.assignEmployeeForm.value.assign;
    const employeeId: string = employeeInfo?.user?.user_uid + '_' + (employeeInfo?.team?.team_uid || '');
    if (employeeId) {
      if (event?.target?.checked === true) {
        assignedEmployees.push(employeeId);
        this.assignEmployeeForm.controls.assign.setValue(assignedEmployees);
      } else {
        this.assignEmployeeForm.controls.assign.setValue(assignedEmployees.filter(user => user !== employeeId));
      }
    }
  }

  selectEmployees(event: any, employeeInfo: any): void {
    this.assignListData = this.assignListData.filter((data: any) => !((data?.user?.user_uid === employeeInfo?.user?.user_uid) && (data?.team?.team_uid === employeeInfo?.team?.team_uid)));
    const employeeId: string = employeeInfo?.user?.user_uid + '_' + (employeeInfo?.team?.team_uid || '');
    if (event?.target?.checked === true) {
      this.assignListData = [...this.assignListData, employeeInfo];
      const selectedUsers: any[] = this.assignEmployeeForm.value.assign || [];
      selectedUsers.push(employeeId);
      this.assignEmployeeForm.controls.assign.setValue(selectedUsers);
    } else {
      const selectedUsers: any[] = this.assignEmployeeForm.value.assign;
      let userIndex: number = -1;
      selectedUsers.forEach((userId: any, index: number) => {
        if (employeeId === userId) {
          userIndex = index;
          return 0;
        }
      });
      if (userIndex > -1) {
        selectedUsers.splice(userIndex, 1);
      }
      this.assignEmployeeForm.controls.assign.setValue(selectedUsers);
    }
  }
  //#endregion

  closeTooltip = (): any => {
    this.assignListData = [];
    this.assignedEmployeeEmitter.emit('close');
  };

}
